<template>
  <v-row class="fill-height" style="margin: 0 5px">
    <v-col>
      <div class="d-md-none" style="float: right">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" icon dark v-bind="attrs" v-on="on">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-5 d-flex flex-column align-stretch">
              <div class="chevs mb-2 align-self-center">
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <v-btn outlined class="mb-3" color="grey darken-2" @click="setToday">Today</v-btn>
          

            <v-btn color="primary" class="mb-3" @click="dialog = true;  setInfoTimeOut();">Add Event</v-btn>
            <v-btn outlined  class="mb-3" color="grey darken-2" v-bind="attrs" v-on="on">
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </v-list>
        </v-menu>
      </div>

      <v-sheet height="64" class="d-none d-md-block">
        <v-toolbar color="white">
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">Today</v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">{{ $refs.calendar.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
              <v-btn
                class="mr-5"
                color="primary"
                @click="dialog = true;  setInfoTimeOut();"
              >Add Event</v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <!-- Add event -->
      <v-dialog v-model="dialog" max-width="500">
        <v-card class="pa-5">
          <h2>Add Event</h2>
          <v-btn
            icon
            @click="dialog = false"
            class="float-right"
            style="position: absolute; right: 10px; top: 10px;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-container>
            <v-form @submit.prevent="addEvent">
              <v-text-field v-model="name" type="text" label="Event Name"></v-text-field>
              <v-text-field v-model="details" type="text" label="Details"></v-text-field>
              <v-text-field v-model="start" type="date" label="Starting Date"></v-text-field>
              <v-text-field v-model="end" type="date" label="Ending Date"></v-text-field>
              <label for>Pick a</label>
              <v-color-picker
                style="border-bottom: 1px solid #999"
                class="ma-2"
                v-model="color"
                :swatches="swatches"
                show-swatches
              ></v-color-picker>

              <v-btn
                style="margin-top: 15px"
                type="submit"
                color="secondary"
                class="mr-4"
                @click="dialog = false"
              >Add event</v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Info -->
      <v-sheet height="600" class="mt-10">
        <v-sheet
          v-show="showCalendar == false"
          height="100%"
          style="padding: 10vh 2vh; text-align: center; margin: 0 auto;"
        >
          <h1>Kalendar - A calendar with a todo!</h1>

          <h3
            style="color: green; margin: 2vh;"
          >Start by click "Add Event" button to add an event on a date.</h3>

          <p>You can set a start/end date and set a color for the event.</p>
          <h3
            style="color: red; margin: 2vh;"
          >This is a prototype app. Please do not input any sensitive information!</h3>
        </v-sheet>

        <v-calendar
          v-show="showCalendar == true"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :now="today"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>

        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card color="grey lighten-4" min-width="350px" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-btn @click="deleteEvent(selectedEvent.id)" icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <form action v-if="currentlyEditing !== selectedEvent.id">{{ selectedEvent.details }}</form>
              <form v-else action>
                <textarea-autosize
                  v-model="selectedEvent.details"
                  type="text"
                  style="width: 100%"
                  :min-height="100"
                  placeholder="add note"
                ></textarea-autosize>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">Cancel</v-btn>
              <v-btn
                text
                v-if="currentlyEditing !== selectedEvent.id"
                @click.prevent="editEvent(selectedEvent)"
              >Edit</v-btn>
              <v-btn text v-else @click.prevent="updateEvent(selectedEvent)">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
      <v-sheet style="padding-top: 20px; text-align: center; margin: 0 auto;">
        <p>
          <em>
            Handcrafted with love and care by
            <a href="https://onurusluca.me">Onur Usluca</a>.
          </em>
        </p>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { db } from "@/main";

export default {
  name: "HelloWorld",

  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: "#1976D2",
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    dialog: false,
    showCalendar: false,
    swatches: [
      ["#FF0000", "#AA0000", "#550000"],
      ["#FFFF00", "#AAAA00", "#555500"],
      ["#00FF00", "#00AA00", "#005500"],
      ["#00FFFF", "#00AAAA", "#005555"],
      ["#0000FF", "#0000AA", "#000055"],
    ],
  }),
  mounted() {
    this.getEvents();
  },
  methods: {
    async getEvents() {
      let snapshot = await db.collection("callEvent").get();
      let events = [];
      snapshot.forEach((doc) => {
        let appData = doc.data();
        appData.id = doc.id;
        events.push(appData);
      });
      this.events = events;
    },
    async addEvent() {
      if (this.name && this.start && this.end) {
        await db.collection("callEvent").add({
          name: this.name,
          details: this.details,
          start: this.start,
          end: this.end,
          color: this.color,
        });
        this.getEvents();
        this.name = "";
        this.details = "";
        this.start = "";
        this.end = "";
        this.color = "";
      } else {
        alert("Name, start and end date are required");
      }
    },
    async updateEvent(ev) {
      await db.collection("callEvent").doc(this.currentlyEditing).update({
        details: ev.details,
      });
      this.selectedOpen = false;
      this.currentlyEditing = null;
    },

    async deleteEvent(ev) {
      await db.collection("callEvent").doc(ev).delete();
      this.selectedOpen = false;
      this.getEvents();
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    editEvent(ev) {
      this.currentlyEditing = ev.id;
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    setInfoTimeOut() {
      this.showCalendar = true;
    },
  },
};
</script>
